import { render } from "./SortOrderUpdateModal.vue?vue&type=template&id=7948d652&scoped=true"
import script from "./SortOrderUpdateModal.vue?vue&type=script&lang=js"
export * from "./SortOrderUpdateModal.vue?vue&type=script&lang=js"

import "./SortOrderUpdateModal.vue?vue&type=style&index=0&id=7948d652&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7948d652"]])

export default __exports__